export default {"src":"/_next/static/media/Download_on_the_App_Store_Badge.a2e763b8.svg","height":40,"width":120};